

import type {
  GetDomainsManagementPlatformServersCountData,
  GetDomainsManagementPlatformServersCountResponse,

  GetDomainsManagementPlatformServersData,
  GetDomainsManagementPlatformServersResponse,

  PostDomainsManagementPlatformServersData,
  PostDomainsManagementPlatformServersResponse,

  GetDomainsManagementPlatformServersByIdData,
  GetDomainsManagementPlatformServersByIdResponse,

  PutDomainsManagementPlatformServersByIdData,
  PutDomainsManagementPlatformServersByIdResponse,

  DeleteDomainsManagementPlatformServersByIdData,
  DeleteDomainsManagementPlatformServersByIdResponse,

  PostDomainsManagementPlatformServersUpdateServersConfigData,
  PostDomainsManagementPlatformServersUpdateServersConfigResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getPlatformServersApiModule(affiliatesApi: AxiosInstance) {
  return {
    /**
     * Get platform servers count
     *
     * @param {Object} params
     * @param {String} params.search
     *
     * @return {Promise<Object>} api response
     */
    getPlatformServersCount(params: GetDomainsManagementPlatformServersCountData['query']) {
      return affiliatesApi.get<GetDomainsManagementPlatformServersCountResponse>(
        '/domains-management/platform-servers/count',
        { params }
      );
    },

    /**
     * Get platform servers
     *
     * @param {Object} params
     * @param {String} params.sort_column
     * @param {String} params.sort_dir
     * @param {String} params.search
     * @param {Number} params.limit
     * @param {Number} params.offset
     *
     * @return {Promise<Object>} api response
     */
    getPlatformServers(params: GetDomainsManagementPlatformServersData['query']) {
      return affiliatesApi.get<GetDomainsManagementPlatformServersResponse>(
        '/domains-management/platform-servers',
        { params }
      );
    },

    /**
     * Create platform server
     *
     * @param {Object} data
     * @param {String} data.name
     * @param {String} data.description
     * @param {String} main_ipv4_address
     * @param {String} main_ipv6_address
     * @param {Array} additional_ipv4_addresses
     * @param {Array} additional_ipv6_addresses
     *
     * @return {Promise<Object>} api response
     */
    createPlatformServer(data: PostDomainsManagementPlatformServersData['body']) {
      return affiliatesApi.post<PostDomainsManagementPlatformServersResponse>(
        '/domains-management/platform-servers',
        data
      );
    },

    /**
     * Get platform server by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    getPlatformServerById(id: string) {
      return affiliatesApi.get<GetDomainsManagementPlatformServersByIdResponse>(
        `/domains-management/platform-servers/${id}`
      );
    },

    /**
     * Update platform server
     *
     * @param {String} id
     * @param {Object} data
     * @param {String} data.name
     * @param {String} data.description
     *
     * @return {Promise<Object>} api response
     */
    updatePlatformServer(id: string, data: PutDomainsManagementPlatformServersByIdData['body']) {
      return affiliatesApi.put<PutDomainsManagementPlatformServersByIdResponse>(
        `/domains-management/platform-servers/${id}`,
        data
      );
    },

    /**
     * Delete platform server by id
     *
     * @param {String} id
     *
     * @return {Promise<Object>} api response
     */
    deletePlatformServer(id: string) {
      return affiliatesApi.delete<DeleteDomainsManagementPlatformServersByIdResponse>(
        `/domains-management/platform-servers/${id}`
      );
    },

    /**
     * Update servers config
     *
     * @return {Promise<Object>} api response
     */
    updatePlatformServersConfig() {
      return affiliatesApi.post<PostDomainsManagementPlatformServersUpdateServersConfigResponse>(
        '/domains-management/platform-servers/update-servers-config'
      );
    },
  }
}
